import { memo } from 'react';

import { Box } from '@mui/material';

import { PageTemplate } from 'components/templates/PageTemplate';
import { PageMapConfig } from 'types/builder/pageConfig';

type PreviewWindowProps = {
    preview: PageMapConfig;
};

const MemoPreview = memo(PageTemplate);

export const PreviewWindow = ({ preview }: PreviewWindowProps): JSX.Element => {
    return (
        <Box
            sx={{
                py: '32px',
                bgcolor: 'white',
                flex: 1,
                overflowX: 'hidden',
            }}
        >
            <MemoPreview page={preview} previewMode />
        </Box>
    );
};
